import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/insight.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-38fe7c5c")

_pushScopeId("data-v-38fe7c5c")
const _hoisted_1 = { class: "flex justify-between items-center pb-2" }
const _hoisted_2 = { class: "flex items-center gap-2 text-red-500 font-medium" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-5 h-5",
  alt: "insight-icon"
}, null, -1)
const _hoisted_4 = { class: "font-semibold text-xs" }
const _hoisted_5 = { class: "flex justify-end gap-2" }
const _hoisted_6 = { class: "card-items relative overflow-hidden" }
const _hoisted_7 = { class: "relative bg-white border-2 border-red-lp-2800 rounded-xl h-full min-h-full py-2 pr-1 lg:pr-4 flex items-start gap-3 overflow-hidden" }
const _hoisted_8 = { class: "step-badge rounded-full" }
const _hoisted_9 = { class: "card-text text-gray-800 pl-12 h-full min-h-0 flex items-center\n              " }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_PopupTopCustomer = _resolveComponent("PopupTopCustomer")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("section", null, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('dashboard.leaderboard.sliderLeaderboard.title')), 1)
        ]),
        _createVNode("div", _hoisted_5, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pages, (p, i) => {
            return (_openBlock(), _createBlock("span", {
              key: i,
              class: ["w-3 h-3 rounded-full cursor-pointer", i === _ctx.activeIndex ? 'bg-red-500' : 'bg-red-200'],
              onClick: ($event: any) => (_ctx.activeIndex = i)
            }, null, 10, ["onClick"]))
          }), 128))
        ])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", {
          class: "flex transition-transform duration-500 ease-in-out h-full",
          style: { transform: `translateX(-${_ctx.activeIndex * 100}%)` }
        }, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pages, (page, pIndex) => {
            return (_openBlock(), _createBlock("div", {
              key: pIndex,
              class: "min-w-full flex gap-2 h-full"
            }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(page, (item, i) => {
                return (_openBlock(), _createBlock("div", {
                  key: i,
                  class: "w-1/2 h-full"
                }, [
                  _createVNode("div", _hoisted_7, [
                    _createVNode("div", _hoisted_8, [
                      _createVNode("span", null, _toDisplayString(pIndex * 2 + i + 1), 1)
                    ]),
                    _createVNode("div", _hoisted_9, [
                      _createVNode("span", {
                        class: "line-clamp-2 text-xs",
                        innerHTML: item.text,
                        onClick: ($event: any) => (
                    item.type === 'topCustomer' && _ctx.onOpenModalTopCustomer()
                  )
                      }, null, 8, ["innerHTML", "onClick"])
                    ])
                  ])
                ]))
              }), 128))
            ]))
          }), 128))
        ], 4),
        _createVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextSlide && _ctx.nextSlide(...args))),
          class: "next-slide-fade absolute top-0 right-0 w-10 h-full flex items-center justify-center"
        }, [
          _createVNode(_component_Icons, {
            name: "chevron-right",
            class: "w-4 h-4 text-red-500 relative z-20"
          })
        ])
      ])
    ]),
    (_ctx.showTopCustomer)
      ? (_openBlock(), _createBlock(_component_PopupTopCustomer, {
          key: 0,
          modelValue: _ctx.showTopCustomer,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.showTopCustomer = $event))
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
})